// @flow
import React from 'react';
import { Field } from 'formik';
import { Button, FormGroup, Label } from 'reactstrap';

const SearchButton = () => (
  <Field>
    {({ form }) => {
      return (
        <FormGroup>
          <Label className="title">Action</Label>
          <div className="input-group">
            <Button color="yellow" onClick={form.handleSubmit}>
              SEARCH
            </Button>
          </div>
        </FormGroup>
      );
    }}
  </Field>
);

export default SearchButton;



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchForm/FormElements/SearchButton.js